import React from 'react';
// import { render } from 'react-dom'
import PropTypes from 'prop-types';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

// Make monochrome colors
/* var pieColors = (function () {
  var colors = ['#'],
      base = Highcharts.getOptions().colors[0],
      i;

  for (i = 0; i < 10; i += 1) {
      // Start out with a darkened base color (negative brighten), and end
      // up with a much brighter color
      colors.push(Highcharts.color(base).brighten((i - 3) / 7).get());
  }
  return colors;
}()); */

const optionsChart = ({title, data}) => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height : '80%',
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      style: {
        fontWeight: 'bold',
        fontFamily: 'Ubuntu'
      }
    },
    plotOptions: {
      pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          colors: ['#00a0af', '#fec600', '#00a0af', '#ABAB40', '#40AB91' ],
          dataLabels: {
              enabled: false,
              format: '<b>{point.name}</b> ',
              distance: -50,
              borderColor: '#ffffff',
              shadow: true,
              // backgroundColor: '#ffffff'
          },
          showInLegend: true
      }
    },
    title: {
      text: title,
      style: {
        fontWeight: 'bold',
        fontFamily: 'Ubuntu',
        fontSize: '140%',
        textAlign: 'left'
      }
    },
    legend : {
      title : {
        style: {
        fontWeight: 'bold',
        fontFamily: 'Ubuntu',
        }
      }
    },
    series: [{
      name: 'Monto',
      colorByPoint: true,
      data
    }],
    credits: {
      enabled: false
    }
  }
}

const Pie = ({ data }) => {
    const options = optionsChart(data)
    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    );
};

Pie.propTypes = {
    data: PropTypes.object.isRequired,
};

export default Pie;